import { Appointment } from 'models/Appointment';

import { AppointmentInfoProps } from 'hooks/useSchedule';

export const mountPickDateUrl = (
  appointment: Appointment | AppointmentInfoProps,
  partnerId: string,
) => {
  const mountedPickDateUrl = `/schedule/pick-date?productId=${appointment.productId}&productSlug=${appointment.productSlug}&partnerId=${partnerId}`;

  if (appointment.quantity > 1) {
    return `${mountedPickDateUrl}&quantity=${appointment.quantity}`;
  }

  return mountedPickDateUrl;
};
